import { render, staticRenderFns } from "./PartnersForm.vue?vue&type=template&id=b050b0b0&"
import script from "./PartnersForm.vue?vue&type=script&lang=js&"
export * from "./PartnersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports